// Function to delete a cookie by name
export function deleteCookie(name: string): void {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}

// Function to get a cookie by name
export function getCookie(name: string): string | null {
  const nameEQ = `${name}=`;
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.indexOf(nameEQ) === 0) {
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  return null;
}

// Function to check if a cookie exists by name
export function hasCookie(name: string): boolean {
  return getCookie(name) !== null;
}


// Function to set a cookie by name, value, and optional attributes
export function setCookie(
  name: string,
  value: string,
  days?: number,
  path: string = '/',
  domain?: string,
  secure?: boolean
): void {
  let cookieString = `${name}=${value}; path=${path};`;

  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    cookieString += `expires=${date.toUTCString()};`;
  }

  if (domain) {
    cookieString += `domain=${domain};`;
  }

  if (secure) {
    cookieString += 'secure;';
  }

  document.cookie = cookieString;
}